import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { CapabilityResponseDataSchema } from "schema"
import z from "zod"
import { capabilitiesQuery } from "../lib/capabilitiesQuery"
import { marketplaceCapabilitiesQuery } from "../lib/marketplaceCapabilitiesQuery"

type Response = {
  data: z.infer<typeof CapabilityResponseDataSchema>
}

export function useUninstallCapabilityMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id }: { id: string }) => {
      const response = await axios.delete<Response>("/capabilities", { data: { id } })

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: capabilitiesQuery().queryKey })
      queryClient.invalidateQueries({ queryKey: marketplaceCapabilitiesQuery().queryKey })
    },
  })
}
